import { createSlice } from '@reduxjs/toolkit';

import {
  createAdminExchange,
  getAdminEditExchange,
  getAdminExchanges,
  updateAdminExchange,
} from './adminExchanges.actions';

const initialState = {
  exchanges: [],
  exchangesMeta: {},
  isLoadingExchanges: false,

  selectedExchange: {},
  isLoadingExchange: false,

  errors: {},
};

const adminExchangesSlice = createSlice({
  name: 'adminExchanges',
  initialState,
  reducers: {
    setAdminExchangesMeta: (state, action) => {
      state.exchangesMeta = action.payload;
    },
    setSelectedExchange: (state, action) => {
      state.selectedExchange = action.payload;
    },
    setAdminExchangeErrors: (state, action) => {
      state.errors = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAdminExchanges.pending, (state) => {
      state.isLoadingExchanges = true;
    });
    builder.addCase(getAdminExchanges.fulfilled, (state, action) => {
      state.exchanges = action.payload;
      state.isLoadingExchanges = false;
    });
    builder.addCase(getAdminExchanges.rejected, (state) => {
      state.isLoadingExchanges = false;
    });

    builder.addCase(createAdminExchange.pending, (state) => {
      state.isLoadingExchange = true;
    });
    builder.addCase(createAdminExchange.fulfilled, (state) => {
      state.isLoadingExchange = false;
    });
    builder.addCase(createAdminExchange.rejected, (state) => {
      state.isLoadingExchange = false;
    });

    builder.addCase(getAdminEditExchange.pending, (state) => {
      state.isLoadingExchange = true;
    });
    builder.addCase(getAdminEditExchange.fulfilled, (state, action) => {
      state.selectedExchange = action.payload;
      state.isLoadingExchange = false;
    });
    builder.addCase(getAdminEditExchange.rejected, (state) => {
      state.isLoadingExchange = false;
    });

    builder.addCase(updateAdminExchange.pending, (state) => {
      state.isLoadingExchange = true;
    });
    builder.addCase(updateAdminExchange.fulfilled, (state) => {
      state.isLoadingExchange = false;
    });
    builder.addCase(updateAdminExchange.rejected, (state) => {
      state.isLoadingExchange = false;
    });
  },
});

export const { setAdminExchangesMeta, setSelectedExchange, setAdminExchangeErrors } =
  adminExchangesSlice.actions;

export default adminExchangesSlice.reducer;
